<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
import { computed, watch } from 'vue'
import translaters from '../../tradutors/assine';
import { localeStore } from '../../stores/locale'
import { planStore } from '../../stores/plans';
import { useHead } from '@unhead/vue'
import { useRoute } from 'vue-router'
import { isMobile } from "../shared/utils/mobile";
import router from '../../router'
import AssineAccountForm from "../../components/Assine/AssineAccountForm.vue";
import { assineChoiceStore } from '../../stores/assineChoice'

const storeLocale = localeStore()
const storePlan = planStore()
const storeAssineChoice = assineChoiceStore()
const route = useRoute()
const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref
const reactiveAssineChoice = computed(() => storeAssineChoice)
const reactivePlans = computed(() => storePlan.plans) 

const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
})

watch(reactivePlans, () => {
    sessionStorage.removeItem('assineChoice')    
    redirect('AssineOptionsPage')
})

useHead({
    templateParams: {
    subTitle: null, 
        subPage: reactiveLocale.value == 'pt-br' ? 'Assine' : 'Subscribe Now',
        page_url: window.location.origin + route.fullPath,
        page_description:
        reactiveLocale.value == 'pt-br'
            ? `Quer ver tudo sem censura? Assine agora e tenha acesso ao conteúdo VIP`
            : `Want to see everything uncensored? Subscribe now and get access to VIP content`,
        page_image: '/favicon.ico',
        page_keywords:
        'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: reactiveLocale.value,
        page_url_pt: 'https://belladasemana.com.br/pt-br/assine',
        page_url_en: 'https://belladasemana.com.br/en/assine',
        page_canonical: 'https://belladasemana.com.br' + route.fullPath
    }
})

function redirect(name) {
    router.push({
        name,
        params: {
            locale: reactiveLocale.value
        }
    })
}

</script>

<template>
    <MainLayout #="{ showModalMessages }">
        <div class="slot-body">        
            <div class="container d-flex">
                <div class="breadcrumb breadcrumb1" @click="redirect('AssineOptionsPage')">{{ translate.breadcrumb1 }}</div>
                <div class="breadcrumb">></div>
                <div class="breadcrumb breadcrumb2">{{ isMobile() ? translate.breadcrumbMobile2 : translate.breadcrumb2 }}</div>
                <div class="breadcrumb">></div>
                <div class="breadcrumb">{{ isMobile() ? translate.breadcrumbMobile3 : translate.breadcrumb3 }}</div>
                <div class="breadcrumb">></div>                
                <div class="breadcrumb">{{ translate.breadcrumb4 }}</div>
            </div>
            <div class="container" v-if="reactiveAssineChoice.choiceId">
                <AssineAccountForm @showModalMessages="showModalMessages"/>
            </div>
            <div class="container py-3" v-else>
                {{ translate.checkPlan }}
            </div>
        </div>
    </MainLayout>    
</template>

<style scoped lang="css">
.slot-body {
    margin-top: 65px !important;    
    background-color: #fff;    
}
.breadcrumb {
    padding: 20px 5px;
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 14px;
    line-height: 16.8px;
    color: #979797;    
    margin-bottom: unset;    
}

.breadcrumb1 {
    color: #5B5858;    
    cursor: pointer;
}

.breadcrumb1:hover {
    text-decoration:underline;
}

.breadcrumb2 {
    color: #5B5858;    
}

/* regras mobile 769px */
@media screen and (max-width: 769px) {
    
}
</style>